<template>
  <MaskedInput
    v-model="context.model"
    v-bind="context.attributes"
    :mask="mask"
    :allow-paste="allowPaste"
    :only-number="onlyNumber"
  />
</template>

<script>
import MaskedInput from './MaskedInput.vue';

export default {
  components: {
    MaskedInput,
  },
  props: {
    context: {
      type: Object,
      required: true,
    },
    mask: {
      type: String,
      required: true,
    },
    allowPaste: {
      type: Boolean,
      default: true,
    },
    onlyNumber: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss"></style>
